/* eslint no-unused-vars: 0 */  // --> OFF

import {useAtom} from 'jotai';
import authenticatedAtom from '../../atoms/authenticatedAtom';
import {Fieldset, Input, Text, Button, VStack, Box, Center} from "@chakra-ui/react";
import {Field} from "../../components/ui/field";
import {Flex} from '@chakra-ui/react';
import {Avatar} from "../../components/ui/avatar";
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import dayjs from "dayjs";
import {useState, useRef, useEffect} from "react";
import userAtom from '../../atoms/userAtom';
import PasswordChange from "../../components/PasswordChange";

const baseUrl = process.env.REACT_APP_API_URL;

const Profile = () => {
    const [isEditing, setIsEditing] = useState(false);
    const fileInputRef = useRef(null);
    const [showPasswordDialog, setShowPasswordDialog] = useState(false);
    const [authenticated] = useAtom(authenticatedAtom);
    const [user, setUser] = useAtom(userAtom);
    const lastPasswordChangeDate = user?.last_password_change
        ? dayjs(user.last_password_change)
        : dayjs(user.created_at);

    const daysSinceChange = dayjs().diff(lastPasswordChangeDate, "day");
    const isPasswordOld = daysSinceChange > 20;

    useEffect(() => {
        if (isPasswordOld) {
            setShowPasswordDialog(true);
        }
    }, [isPasswordOld]);

    const formattedCreatedAt = user?.created_at
        ? dayjs(user.created_at).format("DD-MM-YYYY")
        : "N/A";

    const formattedPasswordChange = lastPasswordChangeDate
        ? lastPasswordChangeDate.format("DD-MM-YYYY")
        : formattedCreatedAt;

    useEffect(() => {
        // Fetch user data when the component mounts
        const fetchUserData = async () => {
            try {
                // Check if the user is authenticated. If not redirect to login
                // if (!authenticated) {
                //     return <Navigate to="/login"/>;
                // }

                const token = localStorage.getItem('token'); // Retrieve token from local storage
                const response = await fetch(`${baseUrl}/auth/user/me`, { // Replace with your API endpoint
                    headers: {
                        Authorization: `Bearer ${token}`, // Include the token in the header
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const userData = await response.json();
                console.log(userData);
                setUser(userData); // Update the user state with fetched data
            } catch (error) {
                console.error("Error fetching user data:", error);
                // Handle error, e.g., display an error message to the user
            }
        };

        fetchUserData(); // Call the fetch function
    }, [setUser, authenticated]); // Make sure to include authenticated in the dependency array

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setUser({...user, [name]: value});
    };

    const handleProfilePictureChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Handle file upload logic here.  This is a simplified example.
            // In a real application, you'd likely upload the file to a server
            // and store the URL of the uploaded image.
            const reader = new FileReader();
            reader.onloadend = () => {
                setUser({...user, profilePicture: reader.result}); // Set preview
            };
            reader.readAsDataURL(file);
        }
    };


    // if (!authenticated) {
    //     return <Navigate to="/login"/>;
    // }

    return (
        <Flex direction="column" minH="100vh" bg={"white"}>
            {/*<Header/>*/}
            <Flex flex="1" justify="center">
                <Center>
                    <Fieldset.Root size="lg" minW="xs" p={5} m={10} borderWidth="1px" borderRadius="lg"
                                   alignItems="center"
                                   justifyContent="center">
                        <VStack spacing={4} mt={4}>
                            <Avatar size="xl" name={`${user.name} ${user.lastName}`}
                                    src={user.profilePicture}/> {/* Display profile picture */}
                            <Box textAlign="center">
                                <Text fontSize="lg" fontWeight="bold">{`${user.name} ${user.lastName}`}</Text>
                                {/*<Text fontSize="sm" color="gray.500" display="flex" alignItems="center"*/}
                                {/*      justifyContent="center">*/}
                                {/*    <FiMapPin className="mr-2"/> {user.location}*/}
                                {/*</Text>*/}
                            </Box>
                        </VStack>


                        <Field label="Name">
                            <Input name="name" value={user.name} onChange={handleInputChange} isDisabled/>
                        </Field>
                        <Field label="Last Name">
                            <Input name="lastName" value={user.lastName} onChange={handleInputChange}
                                   isDisabled/>
                        </Field>
                        <Field label="E-mail">
                            <Input name="email" value={user.email} isDisabled/>
                        </Field>
                        {/*<Field label="User Role">*/}
                        {/*    <Input name="title" value={user.role} onChange={handleInputChange} isDisabled={!isEditing}/>*/}
                        {/*</Field>*/}

                        {/*<Field label="Created On">*/}
                        {/*    <Input*/}
                        {/*        name="created_at"*/}
                        {/*        value={formattedCreatedAt}*/}
                        {/*        isDisabled*/}
                        {/*    />*/}
                        {/*</Field>*/}

                        {/*<Field label="Último Cambio de Contraseña">*/}
                        {/*    <Input*/}
                        {/*        name="last_password_change"*/}
                        {/*        value={`${formattedPasswordChange} (hace ${daysSinceChange} días)`}*/}
                        {/*        isDisabled*/}
                        {/*        style={{*/}
                        {/*            color: isPasswordOld ? "red" : "inherit",*/}
                        {/*            fontWeight: isPasswordOld ? "bold" : "normal",*/}
                        {/*        }}*/}
                        {/*    />*/}
                        {/*</Field>*/}

                        {/*{showPasswordDialog &&*/}
                        {/*    <PasswordChange isOpen={showPasswordDialog} onClose={() => setShowPasswordDialog(false)}/>*/}
                        {/*}*/}

                        {/*<PasswordChange/>*/}


                        {/*<Button*/}
                        {/*    variant="outline"*/}
                        {/*    onClick={() => setIsEditing((prev) => !prev)}*/}
                        {/*>*/}
                        {/*    {isEditing ? "Cancelar" : "Cambiar Contraseña"}*/}
                        {/*</Button>*/}

                        {/*{isEditing && <PasswordChange onClose={() => setIsEditing(false)}/>}*/}


                        {/*<Field label="Ubicación">*/}
                        {/*    <NativeSelectRoot>*/}
                        {/*        <NativeSelectField*/}
                        {/*            name="location"*/}
                        {/*            items={["United Kingdom (UK)", "Canada (CA)", "United States (US)", "México (MX)"]}*/}
                        {/*            value={user.location}*/}
                        {/*            onChange={handleInputChange}*/}
                        {/*            isDisabled={!isEditing}*/}
                        {/*        />*/}
                        {/*    </NativeSelectRoot>*/}
                        {/*</Field>*/}

                        {/*{isEditing && (*/}
                        {/*    <Box mt={4}>*/}
                        {/*        <Button as="label" htmlFor="profilePictureUpload">*/}
                        {/*            Subir foto de perfil*/}
                        {/*        </Button>*/}
                        {/*        <Input*/}
                        {/*            type="file"*/}
                        {/*            id="profilePictureUpload"*/}
                        {/*            ref={fileInputRef}*/}
                        {/*            display="none"*/}
                        {/*            onChange={handleProfilePictureChange} // Add onChange handler*/}
                        {/*        />*/}
                        {/*    </Box>*/}
                        {/*)}*/}

                        {/*<Box mt={4} display="flex" justifyContent="space-between">*/}
                        {/*    {isEditing ? (*/}
                        {/*        <>*/}
                        {/*            <Button m={2} colorScheme="blue" onClick={() => setIsEditing(false)}>Guardar</Button>*/}
                        {/*            <Button m={2} colorPalette="red" onClick={() => setIsEditing(false)}>Cancelar</Button>*/}
                        {/*        </>*/}
                        {/*    ) : (*/}
                        {/*        <Button leftIcon={<FiEdit/>} onClick={() => setIsEditing(true)}>Editar Perfil</Button>*/}
                        {/*    )}*/}
                        {/*</Box>*/}
                    </Fieldset.Root>
                </Center>
            </Flex>
        </Flex>
    );
};

export default Profile;